import React from "react";
import { FiInbox } from "react-icons/fi";

const EmptyList = ({ onCreate }) => {
  return (
    <div className="flex flex-1 flex-col text-gray-600 px-3 sm:px-10   h-full ">
      {/* Heading */}
      <h1 className="text-2xl sm:text-4xl font-bold text-gray-800">
        AI Chatbots
      </h1>

      {/* Empty icon and message */}
      <div className="w-full h-full flex flex-1 flex-col  items-center justify-center  text-center">
        <FiInbox size={48} className="mb-3 text-gray-400" />
        <p className="text-lg font-medium">No bots available</p>
        <p className="text-sm text-gray-400 mt-1">
          You haven’t created any bots yet.
        </p>

        {/* Create New Bot Button */}
        <button
          onClick={onCreate}
          className="mt-6 px-5 py-2 bg-black text-white rounded-lg hover:bg-gray-800 transition">
          Create New Bot
        </button>
      </div>
    </div>
  );
};

export default EmptyList;
